export default __webpack_public_path__ + "static/media/item-1.61c20025.webp";